import { create } from "zustand";

interface LoadingState {
  isLoading: boolean;
  message: string | null;

  // Actions
  setLoading: (loading: boolean, message?: string) => void;
  showLoading: (message?: string) => void;
  hideLoading: () => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  isLoading: false,
  message: null,

  setLoading: (loading: boolean, message?: string) => {
    set({ isLoading: loading, message: message || null });
  },

  showLoading: (message?: string) => {
    set({ isLoading: true, message: message || null });
  },

  hideLoading: () => {
    set({ isLoading: false, message: null });
  },
}));
